import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import {
  Segment,
  Table,
  Grid,
  Icon,
  Image,
  Divider,
  Button,
  Dropdown,
} from "semantic-ui-react";
import { PDFExport } from "@progress/kendo-react-pdf";

import find from "lodash/find";
import filter from "lodash/filter";
import titleCase from "title-case";

import "./Facsimile.css";
import constants from "../../constants";

const _ = {
  find,
  filter,
};

const changeCase = {
  titleCase: titleCase,
};

class FacsimileDetailsPV extends Component {
  state = {
    showAverage: false,
    showAverage1: false,
    showAverage2: false,
  };

  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };

  toggleAverage = () =>
    this.setState((prevState) => ({ showAverage: !prevState.showAverage }));
  toggleAverage1 = () =>
    this.setState((prevState) => ({ showAverage1: !prevState.showAverage1 }));
  toggleAverage2 = () =>
    this.setState((prevState) => ({ showAverage2: !prevState.showAverage2 }));

  componentDidMount() {
    this.setState({
      showAverage: this.props.sectionStudent.showFinalGradeAverage,
      showAverage1: this.props.sectionStudent.showFinalGradeAverage1,
      showAverage2: this.props.sectionStudent.showFinalGradeAverage2,
    });
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      JSON.stringify(prevProps.sectionStudent) !==
      JSON.stringify(this.props.sectionStudent)
    ) {
      this.setState({
        showAverage: this.props.sectionStudent.showFinalGradeAverage,
        showAverage1: this.props.sectionStudent.showFinalGradeAverage1,
        showAverage2: this.props.sectionStudent.showFinalGradeAverage2,
      });
    }
  };

  renderAverage = (classConduct, subjectCategories, sem) => {
    const { sectionSubjects, summary } = this.props;
    let conductsFinalGrade = 0;
    let finalGradeSHSArray = subjectCategories.map((subjectCategory, key) => {
      const subject = _.find(
        sectionSubjects,
        (o) => o.subject.subjectCategory === subjectCategory.value
      );
      if (subject != null) {
        const grade = _.find(
          summary.grades,
          (o) => o.sectionSubjectId === subject.sectionSubjectId
        );
        if (sem === 1) {
          if (grade.secondQuarter !== 0) {
            return Math.round((grade.firstQuarter + grade.secondQuarter) / 2);
          } else {
            return undefined;
          }
        } else {
          if (grade.fourthQuarter !== 0) {
            return Math.round((grade.thirdQuarter + grade.fourthQuarter) / 2);
          } else {
            return undefined;
          }
        }
      } else {
        return undefined;
      }
    });

    finalGradeSHSArray = finalGradeSHSArray.filter(function (element) {
      return element !== undefined;
    });

    if (sem === 1) {
      if (classConduct.firstQuarterFinal !== 0) {
        conductsFinalGrade = Math.round(
          (classConduct.firstQuarterFinal + classConduct.secondQuarterFinal) / 2
        );
      } else {
        conductsFinalGrade = "";
      }
    } else {
      if (classConduct.fourthQuarterFinal !== 0) {
        conductsFinalGrade = Math.round(
          (classConduct.thirdQuarterFinal + classConduct.fourthQuarterFinal) / 2
        );
      } else {
        conductsFinalGrade = "";
      }
    }

    let finalGradesTotal = 0;
    let finalGradesAverage = 0;
    for (let i = 0; i < finalGradeSHSArray.length; i++) {
      finalGradesTotal = finalGradesTotal + finalGradeSHSArray[i];
    }
    finalGradesAverage = finalGradesTotal / finalGradeSHSArray.length;
    finalGradesAverage = parseFloat(
      finalGradesAverage * 0.9 + conductsFinalGrade * 0.1
    ).toFixed(2);
    if (subjectCategories.length !== finalGradeSHSArray.length) {
      finalGradesAverage = "INC";
    } else {
      finalGradesAverage = Math.round(finalGradesAverage);
    }
    return finalGradesAverage;
  };

  renderTableRows = (subjectCategories, sem) => {
    const { sectionSubjects, summary } = this.props;
    const tableRow = subjectCategories.map((subjectCategory, key) => {
      const subject = _.find(
        sectionSubjects,
        (o) => o.subject.subjectCategory === subjectCategory.value
      );
      console.log(subject);
      if (subject != null) {
        const grade = _.find(
          summary.grades,
          (o) => o.sectionSubjectId === subject.sectionSubjectId
        );
        if (sem === 1) {
          return (
            <Table.Row key={key} className="students-table-row">
              <Table.Cell>
                <span>{subjectCategory.text}</span>
              </Table.Cell>
              <Table.Cell>
                {grade
                  ? grade.firstQuarter !== 0
                    ? grade.firstQuarter
                    : ""
                  : ""}
              </Table.Cell>
              <Table.Cell>
                {grade
                  ? grade.secondQuarter !== 0
                    ? grade.secondQuarter
                    : ""
                  : ""}
              </Table.Cell>
              <Table.Cell style={{ textAlign: "center", fontWeight: "900" }}>
                {grade
                  ? grade.firstQuarter !== 0 && grade.secondQuarter !== 0
                    ? Math.round((grade.firstQuarter + grade.secondQuarter) / 2)
                    : ""
                  : ""}
              </Table.Cell>
            </Table.Row>
          );
        } else {
          return (
            <Table.Row key={key} className="students-table-row">
              <Table.Cell>
                <span>{subjectCategory.text}</span>
              </Table.Cell>
              <Table.Cell>
                {grade
                  ? grade.thirdQuarter !== 0
                    ? grade.thirdQuarter
                    : ""
                  : ""}
              </Table.Cell>
              <Table.Cell>
                {grade
                  ? grade.fourthQuarter !== 0
                    ? grade.fourthQuarter
                    : ""
                  : ""}
              </Table.Cell>
              <Table.Cell style={{ textAlign: "center", fontWeight: "900" }}>
                {grade
                  ? grade.thirdQuarter !== 0 && grade.fourthQuarter !== 0
                    ? Math.round((grade.thirdQuarter + grade.fourthQuarter) / 2)
                    : ""
                  : ""}
              </Table.Cell>
            </Table.Row>
          );
        }
      } else {
        return (
          <Table.Row key={key} className="students-table-row">
            <Table.Cell>
              <span>{subjectCategory.text}</span>
            </Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
        );
      }
    });
    return tableRow;
  };

  render() {
    if (this.props.auth) {
      if (
        this.props.userType === "admin" ||
        this.props.userType === "principal" ||
        this.props.userType === "registrar" ||
        this.props.userType === "adviser" ||
        this.props.userType === "levelHead"
      ) {
        const {
          sectionStudent,
          sectionSubjects,
          summary,
          daysOfSchool,
          attendance,
          schoolYear,
          remarks,
          teachers,
          sectionStudents,
          sectionStudentId,
        } = this.props;
        let MAPEHStyle = { paddingLeft: "0" };
        let finalGradeArray = [],
          conductsFinalGrade = 0,
          subjectsCount = 0;
        let subjectCategories = constants.subjectCategory;
        if (sectionStudent.section.levelType === "ELEMP") {
          if (sectionStudent.section.gradeLevel === "Grade 1") {
            subjectCategories = constants.subjectGrade1;
          } else {
            subjectCategories = constants.subjectElemP;
          }
        } else if (sectionStudent.section.levelType === "ELEMI") {
          if (sectionStudent.section.gradeLevel === "Grade 4") {
            subjectCategories = constants.subjectGrade4;
          } else {
            subjectCategories = constants.subjectElemI;
          }
        } else if (sectionStudent.section.levelType === "JHS") {
          if (sectionStudent.section.gradeLevel === "Grade 7") {
            subjectCategories = constants.subjectGrade7;
          } else {
            subjectCategories = constants.subjectJHS;
          }
        } else if (sectionStudent.section.levelType === "SHSHUMSS") {
          if (sectionStudent.section.gradeLevel === "Grade 11 - HUMMS") {
            subjectCategories = constants.subjectHUMSSSHS11;
          } else {
            subjectCategories = constants.subjectHUMSSSHS12;
          }
        } else if (sectionStudent.section.levelType === "SHSSTEM") {
          if (sectionStudent.section.gradeLevel === "Grade 11 - STEM") {
            subjectCategories = constants.subjectSTEMSHS11;
          } else {
            subjectCategories = constants.subjectSTEMSHS12;
          }
        } else if (sectionStudent.section.levelType === "SHSABM") {
          if (sectionStudent.section.gradeLevel === "Grade 11 - ABM") {
            subjectCategories = constants.subjectABMSHS11;
          } else {
            subjectCategories = constants.subjectABMSHS12;
          }
        }

        let subjectBody = [],
          firstSemCore = [],
          firstSemApplied = [],
          secondSemCore = [],
          secondSemApplied = [];
        if (
          sectionStudent.section.levelType === "SHSHUMSS" ||
          sectionStudent.section.levelType === "SHSSTEM" ||
          sectionStudent.section.levelType === "SHSABM"
        ) {
          firstSemCore = this.renderTableRows(subjectCategories.Core1, 1);
          firstSemApplied = this.renderTableRows(
            subjectCategories.AppliedAndSpecializedSubjects1,
            1
          );

          secondSemCore = this.renderTableRows(subjectCategories.Core2, 2);
          secondSemApplied = this.renderTableRows(
            subjectCategories.AppliedAndSpecializedSubjects2,
            2
          );
        } else {
          const mapehSubjects = _.filter(
            sectionSubjects,
            (o) =>
              o.subject.subjectCategory === "Music" ||
              o.subject.subjectCategory === "Arts" ||
              o.subject.subjectCategory === "Physical Education" ||
              o.subject.subjectCategory === "Health" ||
              o.subject.subjectCategory === "Music and Arts" ||
              o.subject.subjectCategory === "PEH"
          );
          console.log("@@@ mapeh subjects", mapehSubjects);
          subjectBody = subjectCategories.map((subjectCategory, key) => {
            let subCatValue = subjectCategory.value;
            if (
              sectionStudent.section.gradeLevel === "Grade 3" &&
              subjectCategory.value === "SciEnglish"
            ) {
              return null;
            }
            if (
              (sectionStudent.section.gradeLevel === "Grade 1" ||
                sectionStudent.section.gradeLevel === "Grade 2") &&
              (subjectCategory.value === "English" ||
                subjectCategory.value === "Science")
            ) {
              return null;
            }
            const subject = _.find(
              sectionSubjects,
              (o) => o.subject.subjectCategory === subCatValue
            );
            if (subject != null) {
              const grade = _.find(
                summary.grades,
                (o) => o.sectionSubjectId === subject.sectionSubjectId
              );
              let finalGrade = 0;
              if (grade) {
                if (grade.fourthQuarter !== 0) {
                  finalGrade =
                    grade.firstQuarter +
                    grade.secondQuarter +
                    grade.thirdQuarter +
                    grade.fourthQuarter;
                  finalGrade = Math.round(finalGrade / 4);
                }
                if (
                  subjectCategory.value === "Music" ||
                  subjectCategory.value === "Arts" ||
                  subjectCategory.value === "Physical Education" ||
                  subjectCategory.value === "Health"
                ) {
                  MAPEHStyle = { paddingLeft: "30px" };
                } else {
                  MAPEHStyle = { paddingLeft: "0" };
                  finalGradeArray.push(finalGrade);
                  subjectsCount++;
                }
              }

              return (
                <Table.Row key={key} className="students-table-row">
                  <Table.Cell textAlign="center">
                    <span style={MAPEHStyle}>{subjectCategory.text}</span>
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {grade
                      ? grade.firstQuarter !== 0
                        ? grade.firstQuarter
                        : ""
                      : ""}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {grade
                      ? grade.secondQuarter !== 0
                        ? grade.secondQuarter
                        : ""
                      : ""}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {grade
                      ? grade.thirdQuarter !== 0
                        ? grade.thirdQuarter
                        : ""
                      : ""}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {grade
                      ? grade.fourthQuarter !== 0
                        ? grade.fourthQuarter
                        : ""
                      : ""}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {grade ? (grade.fourthQuarter !== 0 ? finalGrade : "") : ""}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {finalGrade === 0
                      ? ""
                      : finalGrade < 75
                      ? "Failed"
                      : "Passed"}
                  </Table.Cell>
                </Table.Row>
              );
            } else {
              if (subjectCategory.value === "MAPEH") {
                let mapeh1 = 0,
                  mapeh2 = 0,
                  mapeh3 = 0,
                  mapeh4 = 0,
                  mapehFinal = 0;
                let hasZeroGrade1 = false,
                  hasZeroGrade2 = false,
                  hasZeroGrade3 = false,
                  hasZeroGrade4 = false;
                for (let i = 0; i < mapehSubjects.length; i++) {
                  const grade = _.find(
                    summary.grades,
                    (o) =>
                      o.sectionSubjectId === mapehSubjects[i].sectionSubjectId
                  );
                  if (grade != null) {
                    if (grade.firstQuarter === 0) {
                      hasZeroGrade1 = true;
                    }
                    if (grade.secondQuarter === 0) {
                      hasZeroGrade2 = true;
                    }
                    if (grade.thirdQuarter === 0) {
                      hasZeroGrade3 = true;
                    }
                    if (grade.fourthQuarter === 0) {
                      hasZeroGrade4 = true;
                    }
                    mapeh1 += grade.firstQuarter;
                    mapeh2 += grade.secondQuarter;
                    mapeh3 += grade.thirdQuarter;
                    mapeh4 += grade.fourthQuarter;
                  }
                }

                if (hasZeroGrade1) {
                  mapeh1 = 0;
                }

                if (hasZeroGrade2) {
                  mapeh2 = 0;
                }

                if (hasZeroGrade3) {
                  mapeh3 = 0;
                }

                if (hasZeroGrade4) {
                  mapeh4 = 0;
                }

                mapeh1 =
                  mapeh1 === 0 ? 0 : Math.round(mapeh1 / mapehSubjects.length);
                mapeh2 =
                  mapeh2 === 0 ? 0 : Math.round(mapeh2 / mapehSubjects.length);
                mapeh3 =
                  mapeh3 === 0 ? 0 : Math.round(mapeh3 / mapehSubjects.length);
                mapeh4 =
                  mapeh4 === 0 ? 0 : Math.round(mapeh4 / mapehSubjects.length);
                mapehFinal =
                  mapeh4 === 0
                    ? 0
                    : Math.round((mapeh1 + mapeh2 + mapeh3 + mapeh4) / 4);
                finalGradeArray.push(mapehFinal);
                subjectsCount++;
                return (
                  <Table.Row key={key} className="students-table-row">
                    <Table.Cell>
                      <span style={MAPEHStyle}>{subjectCategory.text}</span>
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {mapeh1 === 0 || mapeh1 < 70 ? "" : mapeh1}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {mapeh2 === 0 || mapeh2 < 70 ? "" : mapeh2}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {mapeh3 === 0 || mapeh3 < 70 ? "" : mapeh3}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {mapeh4 === 0 || mapeh4 < 70 ? "" : mapeh4}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {mapehFinal === 0 || mapehFinal < 70 ? "" : mapehFinal}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {mapehFinal === 0
                        ? ""
                        : mapehFinal < 75
                        ? "Failed"
                        : "Passed"}
                    </Table.Cell>
                  </Table.Row>
                );
              } else {
                return (
                  <Table.Row key={key} className="students-table-row">
                    <Table.Cell>
                      <span style={MAPEHStyle}>{subjectCategory.text}</span>
                    </Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                );
              }
            }
          });
        }
        let department = "";
        if (
          sectionStudent.section.levelType === "ELEMP" ||
          sectionStudent.section.levelType === "ELEMI"
        ) {
          department = "ELEMENTARY LEVEL";
        } else if (sectionStudent.section.levelType === "JHS") {
          department = "JUNIOR HIGH SCHOOL LEVEL";
        } else if (
          sectionStudent.section.levelType === "SHSSTEM" ||
          sectionStudent.section.levelType === "SHSHUMSS" ||
          sectionStudent.section.levelType === "SHSABM"
        ) {
          department = "SENIOR HIGH SCHOOL LEVEL";
        }
        const adviser = _.find(
          teachers,
          (o) => o.teacherId === sectionStudent.section.teacherId
        );
        if (sectionStudent.classConducts.length !== 0) {
          if (sectionStudent.classConducts[0].fourthQuarterFinal !== 0) {
            conductsFinalGrade = Math.round(
              (sectionStudent.classConducts[0].firstQuarterFinal +
                sectionStudent.classConducts[0].secondQuarterFinal +
                sectionStudent.classConducts[0].thirdQuarterFinal +
                sectionStudent.classConducts[0].fourthQuarterFinal) /
                4
            );
          } else {
            conductsFinalGrade = "";
          }
        } else {
          conductsFinalGrade = "";
        }

        let finalGradesTotal = 0;
        let finalGradesAverage = 0;
        for (let i = 0; i < finalGradeArray.length; i++) {
          finalGradesTotal = finalGradesTotal + finalGradeArray[i];
        }
        finalGradesAverage = finalGradesTotal / finalGradeArray.length;
        finalGradesAverage = parseFloat(
          finalGradesAverage * 0.9 + conductsFinalGrade * 0.1
        );
        if (subjectsCount !== finalGradeArray.length) {
          finalGradesAverage = "INC";
        } else {
          finalGradesAverage = Math.round(finalGradesAverage);
        }

        let optionsSectionStudents;
        if (sectionStudents) {
          optionsSectionStudents = sectionStudents.map((i, index) => {
            const displayText = i.student.lastName + ", " + i.student.firstName;
            return { key: i, value: i.sectionStudentId, text: displayText };
          });
        }
        console.log(sectionStudent);
        let classConduct;
        if (sectionStudent.classConducts.length > 1) {
          // find sectionStudent.classConducts where sectionId === sectionStudent.sectionId
          classConduct = sectionStudent.classConducts.find(
            (conduct) => conduct.sectionId === sectionStudent.sectionId
          );
        } else if (sectionStudent.classConducts.length === 1) {
          classConduct = sectionStudent.classConducts[0];
        } else {
          classConduct = null;
        }
        console.log(classConduct);
        return (
          <div>
            {(this.props.userType === "admin" ||
              this.props.userType === "principal" ||
              this.props.userType === "registrar" ||
              this.props.userType === "adviser") && (
              <Grid centered>
                <Grid.Row>
                  <Dropdown
                    selection
                    name="sectionStudentId"
                    options={optionsSectionStudents}
                    onChange={this.props.handleChange}
                    value={sectionStudentId}
                  />
                </Grid.Row>
              </Grid>
            )}
            <PDFExport
              ref={(component) => (this.pdfExportComponent = component)}
              paperSize="auto"
              margin={40}
              fileName={`Report for Card for ${changeCase.titleCase(
                sectionStudent.student.lastName
              )}, ${changeCase.titleCase(sectionStudent.student.firstName)}`}
              author="SALIS"
            >
              <Grid>
                <Grid.Row centered>
                  <Grid.Column width={10}>
                    <Image src="/salis_letter_head.png" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row centered style={{ margin: 0, padding: 0 }}>
                  <Grid.Column width={15} style={{ margin: 0, padding: 0 }}>
                    <Divider />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row centered style={{ margin: 0, padding: 0 }}>
                  <Grid.Column
                    width={16}
                    style={{ margin: 0, padding: 0, textAlign: "center" }}
                  >
                    <h1 style={{ marginBottom: 0 }}>
                      REPORT ON STUDENT PERFORMANCE
                    </h1>
                    <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                      {" "}
                      {department}{" "}
                    </h3>
                    <h3 style={{ marginTop: 0 }}> SY {schoolYear.name} </h3>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={10}>
                    <p>
                      Name:{" "}
                      {changeCase.titleCase(sectionStudent.student.lastName)},{" "}
                      {changeCase.titleCase(sectionStudent.student.firstName)}{" "}
                      {changeCase.titleCase(sectionStudent.student.middleName)}
                      <br />
                      Section: {sectionStudent.section.gradeLevel} -{" "}
                      {sectionStudent.section.name}
                    </p>
                  </Grid.Column>
                  <Grid.Column width={4} floated="right">
                    <p>
                      LRN: {sectionStudent.student.lrn} <br />
                      Adviser: {changeCase.titleCase(adviser.firstName)}{" "}
                      {changeCase.titleCase(adviser.lastName)}
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid centered>
                {sectionStudent.section.levelType === "SHSHUMSS" ||
                sectionStudent.section.levelType === "SHSSTEM" ||
                sectionStudent.section.levelType === "SHSABM" ? (
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Table celled size="small">
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell rowSpan="2" textAlign="center">
                              Subject
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan="2" textAlign="center">
                              Quarter
                            </Table.HeaderCell>
                            <Table.HeaderCell rowSpan="2" textAlign="center">
                              Final Grade
                            </Table.HeaderCell>
                          </Table.Row>
                          <Table.Row>
                            <Table.HeaderCell
                              collapsing
                              style={{
                                borderLeft: "1px solid rgba(34,36,38,.1)",
                              }}
                            >
                              1
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing>2</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          <Table.Row className="students-table-row">
                            <Table.Cell
                              colSpan="4"
                              style={{ backgroundColor: "#E0E0E0" }}
                            >
                              <strong>Core Subjects</strong>
                            </Table.Cell>
                          </Table.Row>
                          {firstSemCore}
                          <Table.Row className="students-table-row">
                            <Table.Cell
                              colSpan="4"
                              style={{ backgroundColor: "#E0E0E0" }}
                            >
                              <strong>Applied and Specialized Subjects</strong>
                            </Table.Cell>
                          </Table.Row>
                          {firstSemApplied}
                          <Table.Row className="students-table-row">
                            <Table.Cell>
                              <span style={{ float: "right" }}>AVERAGE</span>
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell textAlign="center">
                              {this.state.showAverage1 ? (
                                this.renderAverage(
                                  sectionStudent.classConducts[0],
                                  subjectCategories.Core1.concat(
                                    subjectCategories.AppliedAndSpecializedSubjects1
                                  ),
                                  1
                                )
                              ) : (
                                <span>
                                  {(this.props.userType === "admin" ||
                                    this.props.userType === "principal" ||
                                    this.props.userType === "registrar") && (
                                    <Icon
                                      name="eye"
                                      size="large"
                                      style={{ cursor: "pointer" }}
                                      onClick={this.toggleAverage1}
                                    />
                                  )}
                                </span>
                              )}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row className="students-table-row">
                            <Table.Cell>
                              <span>Conduct</span>
                            </Table.Cell>
                            <Table.Cell>
                              {sectionStudent.classConducts.length !== 0
                                ? sectionStudent.classConducts[0]
                                    .firstQuarterFinal
                                : ""}
                            </Table.Cell>
                            <Table.Cell>
                              {sectionStudent.classConducts.length !== 0
                                ? sectionStudent.classConducts[0]
                                    .secondQuarterFinal !== 0
                                  ? sectionStudent.classConducts[0]
                                      .secondQuarterFinal
                                  : ""
                                : ""}
                            </Table.Cell>
                            <Table.Cell
                              style={{ textAlign: "center", fontWeight: "900" }}
                            >
                              {sectionStudent.classConducts.length
                                ? sectionStudent.classConducts[0]
                                    .firstQuarterFinal !== 0 &&
                                  sectionStudent.classConducts[0]
                                    .secondQuarterFinal !== 0
                                  ? Math.round(
                                      (sectionStudent.classConducts[0]
                                        .firstQuarterFinal +
                                        sectionStudent.classConducts[0]
                                          .secondQuarterFinal) /
                                        2
                                    )
                                  : ""
                                : ""}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Table celled size="small">
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell rowSpan="2" textAlign="center">
                              Subject
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan="2" textAlign="center">
                              Quarter
                            </Table.HeaderCell>
                            <Table.HeaderCell rowSpan="2" textAlign="center">
                              Final Grade
                            </Table.HeaderCell>
                          </Table.Row>
                          <Table.Row>
                            <Table.HeaderCell
                              collapsing
                              style={{
                                borderLeft: "1px solid rgba(34,36,38,.1)",
                              }}
                            >
                              3
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing>4</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          <Table.Row className="students-table-row">
                            <Table.Cell
                              colSpan="4"
                              style={{ backgroundColor: "#E0E0E0" }}
                            >
                              <strong>Core Subjects</strong>
                            </Table.Cell>
                          </Table.Row>
                          {secondSemCore}
                          <Table.Row className="students-table-row">
                            <Table.Cell
                              colSpan="4"
                              style={{ backgroundColor: "#E0E0E0" }}
                            >
                              <strong>Applied and Specialized Subjects</strong>
                            </Table.Cell>
                          </Table.Row>
                          {secondSemApplied}
                          <Table.Row className="students-table-row">
                            <Table.Cell>
                              <span style={{ float: "right" }}>AVERAGE</span>
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell textAlign="center">
                              {this.state.showAverage2 ? (
                                this.renderAverage(
                                  sectionStudent.classConducts[0],
                                  subjectCategories.Core2.concat(
                                    subjectCategories.AppliedAndSpecializedSubjects2
                                  ),
                                  2
                                )
                              ) : (
                                <span>
                                  {(this.props.userType === "admin" ||
                                    this.props.userType === "principal" ||
                                    this.props.userType === "registrar") && (
                                    <Icon
                                      name="eye"
                                      size="large"
                                      style={{ cursor: "pointer" }}
                                      onClick={this.toggleAverage2}
                                    />
                                  )}
                                </span>
                              )}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row className="students-table-row">
                            <Table.Cell>
                              <span>Conduct</span>
                            </Table.Cell>
                            <Table.Cell>
                              {sectionStudent.classConducts &&
                              sectionStudent.classConducts.length !== 0 &&
                              sectionStudent.classConducts[0]
                                .thirdQuarterFinal !== 0
                                ? sectionStudent.classConducts[0]
                                    .thirdQuarterFinal
                                : ""}
                            </Table.Cell>
                            <Table.Cell>
                              {sectionStudent.classConducts &&
                              sectionStudent.classConducts.length !== 0 &&
                              sectionStudent.classConducts[0]
                                .fourthQuarterFinal !== 0
                                ? sectionStudent.classConducts[0]
                                    .fourthQuarterFinal
                                : ""}
                            </Table.Cell>
                            <Table.Cell
                              style={{ textAlign: "center", fontWeight: "900" }}
                            >
                              {sectionStudent.classConducts &&
                              sectionStudent.classConducts.length !== 0 &&
                              sectionStudent.classConducts[0]
                                .thirdQuarterFinal !== 0 &&
                              sectionStudent.classConducts[0]
                                .fourthQuarterFinal !== 0
                                ? Math.round(
                                    (sectionStudent.classConducts[0]
                                      .thirdQuarterFinal +
                                      sectionStudent.classConducts[0]
                                        .fourthQuarterFinal) /
                                      2
                                  )
                                : ""}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </Grid.Column>
                  </Grid.Row>
                ) : (
                  <Grid.Row>
                    <Grid.Column
                      width={
                        sectionStudent.section.levelType !== "JHS" ? 8 : 10
                      }
                    >
                      <Table celled size="small">
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell rowSpan="2" textAlign="center">
                              Subject
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan="5" textAlign="center">
                              Grades
                            </Table.HeaderCell>
                            <Table.HeaderCell rowSpan="2" textAlign="center">
                              Action Taken
                            </Table.HeaderCell>
                          </Table.Row>
                          <Table.Row>
                            <Table.HeaderCell
                              collapsing
                              textAlign="center"
                              style={{
                                borderLeft: "1px solid rgba(34,36,38,.1)",
                              }}
                            >
                              1st
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing textAlign="center">
                              2nd
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing textAlign="center">
                              3rd
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing textAlign="center">
                              4th
                            </Table.HeaderCell>
                            <Table.HeaderCell collapsing textAlign="center">
                              Final
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          {subjectBody}
                          <Table.Row className="students-table-row">
                            <Table.Cell>
                              <span style={{ float: "right" }}>AVERAGE</span>
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell textAlign="center">
                              <strong>
                                {this.state.showAverage ? (
                                  finalGradesAverage
                                ) : (
                                  <span>
                                    {(this.props.userType === "admin" ||
                                      this.props.userType === "principal" ||
                                      this.props.userType === "registrar") && (
                                      <Icon
                                        name="eye"
                                        size="large"
                                        style={{ cursor: "pointer" }}
                                        onClick={this.toggleAverage}
                                      />
                                    )}
                                  </span>
                                )}
                              </strong>
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {this.state.showAverage &&
                              finalGradesAverage !== "INC"
                                ? "Promoted"
                                : ""}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row className="students-table-row">
                            <Table.Cell>
                              <span>Conduct</span>
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {classConduct &&
                              classConduct.firstQuarterFinal === 0
                                ? ""
                                : classConduct
                                ? classConduct.firstQuarterFinal
                                : ""}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {classConduct &&
                              classConduct.secondQuarterFinal === 0
                                ? ""
                                : classConduct
                                ? classConduct.secondQuarterFinal
                                : ""}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {classConduct &&
                              classConduct.thirdQuarterFinal === 0
                                ? ""
                                : classConduct
                                ? classConduct.thirdQuarterFinal
                                : ""}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              {classConduct &&
                              classConduct.fourthQuarterFinal === 0
                                ? ""
                                : classConduct
                                ? classConduct.fourthQuarterFinal
                                : ""}
                            </Table.Cell>

                            <Table.Cell textAlign="center">
                              {conductsFinalGrade}
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                          </Table.Row>
                        </Table.Body>
                      </Table>
                    </Grid.Column>
                    {sectionStudent.section.levelType !== "JHS" && (
                      <Grid.Column width={8}>
                        <Table celled size="small">
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell
                                textAlign="center"
                                style={{
                                  paddingTop: "36px",
                                  paddingBottom: "36px",
                                }}
                              >
                                Quarter
                              </Table.HeaderCell>
                              <Table.HeaderCell textAlign="center">
                                Remarks
                              </Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>

                          <Table.Body>
                            <Table.Row>
                              <Table.Cell>1st</Table.Cell>
                              <Table.Cell>
                                {remarks ? remarks.firstQuarter : "--"}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell>2nd</Table.Cell>
                              <Table.Cell>
                                {remarks ? remarks.secondQuarter : "--"}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell>3rd</Table.Cell>
                              <Table.Cell>
                                {remarks ? remarks.thirdQuarter : "--"}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell>4th</Table.Cell>
                              <Table.Cell>
                                {remarks ? remarks.fourthQuarter : "--"}
                              </Table.Cell>
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      </Grid.Column>
                    )}
                  </Grid.Row>
                )}

                <Grid.Row>
                  <Grid.Column width={16}>
                    <Table celled compact size="small">
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell textAlign="center">
                            ATTENDANCE
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            JUL
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            AUG
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            SEP
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            OCT
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            NOV
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            DEC
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            JAN
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            FEB
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            MAR
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            APR
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            MAY
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            JUN
                          </Table.HeaderCell>
                          <Table.HeaderCell textAlign="center">
                            TOTAL
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {attendance != null ? (
                          <React.Fragment>
                            <Table.Row>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                Days of School
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.julDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.augDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.sepDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.octDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.novDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.decDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.janDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.febDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.marDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.aprDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.mayDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.junDays}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {daysOfSchool.totalDays}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                Days Present
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.jul}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.aug}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.sep}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.oct}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.nov}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.dec}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.jan}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.feb}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.mar}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.apr}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.may}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.jun}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.total}
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                Times Tardy
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.julTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.augTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.sepTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.octTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.novTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.decTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.janTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.febTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.marTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.aprTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.mayTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.junTardy}
                              </Table.Cell>
                              <Table.Cell
                                className="attendance-table-cell-sample"
                                textAlign="center"
                                collapsing
                              >
                                {attendance.totalTardy}
                              </Table.Cell>
                            </Table.Row>
                          </React.Fragment>
                        ) : (
                          <Table.Row>
                            <Table.Cell
                              textAlign="center"
                              colSpan={14}
                              style={{ color: "gray" }}
                            >
                              <em>Attendance not yet available</em>
                            </Table.Cell>
                          </Table.Row>
                        )}
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </PDFExport>
            <Grid centered>
              <Grid.Row>
                <Icon
                  name="print"
                  size="large"
                  style={{ cursor: "pointer" }}
                  onClick={this.exportPDFWithComponent}
                />
                {this.state.showAverage &&
                  (this.props.userType === "admin" ||
                    this.props.userType === "principal" ||
                    this.props.userType === "registrar") && (
                    <Icon
                      name="eye slash"
                      size="large"
                      style={{ cursor: "pointer" }}
                      onClick={this.toggleAverage}
                    />
                  )}
                {this.state.showAverage1 &&
                  (this.props.userType === "admin" ||
                    this.props.userType === "principal" ||
                    this.props.userType === "registrar") && (
                    <Icon
                      name="eye slash"
                      size="large"
                      style={{ cursor: "pointer" }}
                      onClick={this.toggleAverage1}
                    />
                  )}
                {this.state.showAverage2 &&
                  (this.props.userType === "admin" ||
                    this.props.userType === "principal" ||
                    this.props.userType === "registrar") && (
                    <Icon
                      name="eye slash"
                      size="large"
                      style={{ cursor: "pointer" }}
                      onClick={this.toggleAverage2}
                    />
                  )}
              </Grid.Row>
              {(sectionStudent.section.levelType === "ELEMP" ||
                sectionStudent.section.levelType === "ELEMI" ||
                sectionStudent.section.levelType === "JHS") &&
                (this.props.userType === "admin" ||
                  this.props.userType === "principal" ||
                  this.props.userType === "registrar") && (
                  <Grid.Row>
                    <Button
                      onClick={() =>
                        this.props.handleShowFinalGradeAverage(
                          { showFinalGradeAverage: this.state.showAverage },
                          sectionStudent.sectionStudentId
                        )
                      }
                    >
                      {" "}
                      Save Final Grade Average{" "}
                    </Button>
                  </Grid.Row>
                )}

              {(sectionStudent.section.levelType === "SHSHUMSS" ||
                sectionStudent.section.levelType === "SHSSTEM" ||
                sectionStudent.section.levelType === "SHSABM") &&
                (this.props.userType === "admin" ||
                  this.props.userType === "principal" ||
                  this.props.userType === "registrar") && (
                  <Grid.Row>
                    <Button
                      onClick={() =>
                        this.props.handleShowFinalGradeAverage(
                          { showFinalGradeAverage1: this.state.showAverage1 },
                          sectionStudent.sectionStudentId
                        )
                      }
                    >
                      {" "}
                      Save 1st Sem Final Grade Average{" "}
                    </Button>
                    <Button
                      onClick={() =>
                        this.props.handleShowFinalGradeAverage(
                          { showFinalGradeAverage2: this.state.showAverage2 },
                          sectionStudent.sectionStudentId
                        )
                      }
                    >
                      {" "}
                      Save 2nd Sem Final Grade Average{" "}
                    </Button>
                  </Grid.Row>
                )}
            </Grid>
          </div>
        );
      } else {
        return <Segment>You are not authorized to be in this page.</Segment>;
      }
    } else {
      return <Redirect to="/" />;
    }
  }
}

export default FacsimileDetailsPV;
